import {
  get
} from '../axios'

class Static {
  async getStatic(param) {
    const res = await get('/Static/GetCustVisStatic', param)
    return res
  }
  async CheckPsw(param) {
    const res = await get('/Static/CheckStaticPassWord', param)
    return res
  }
  async getBisProgram(param) {
    const res = await get('/Static/GetBisProgram', param)
    return res
  }
}
export default new Static()